<template>
    <div v-if="way_issue">
        <div class="text-center mt-5">Техничесике неполадки. Свяжитесь с менеджером: +7 747 717 60 60</div>
    </div>
    <div class="card" v-else style="border: 0; padding-top: 50px;">
        <div class="row">
            <aside class="col-sm-5 border-right">
                <div class="slider" style="display: flex; flex-wrap: wrap;">
                    <VueSlickCarousel class="slider-nav" ref="c1" :swipe="false" :draggable="false" :asNavFor="$refs.c2" :vertical="true" :slidesToShow="15" :slidesToScroll="1" :arrows="false" :focusOnSelect="true">
                        <div v-for="image in this.product.images" class="slick-slide">
                            <img :src="axios.defaults.baseImageURL +'uploads/'+ image" />
                        </div>
                    </VueSlickCarousel>
                    <VueSlickCarousel class="slider-for" ref="c2" :asNavFor="$refs.c1" :slidesToShow="1" :arrows="false">
                        <div v-for="image in this.product.images" class="slick-slide">
                            <img :src="axios.defaults.baseImageURL +'uploads/'+ image" />
                        </div>
                    </VueSlickCarousel>
                </div>
            </aside>
            <aside class="col-sm-7">
                <article class="card-body p-5">
                    <h3 class="title mb-3">{{ product.name }}</h3>

                    <p class="price-detail-wrap">
                        <span class="price h3" style="color: #3ca053">
                            <span class="currency"></span><span class="num"></span>
                        </span>
                    </p> <!-- price-detail-wrap .// -->
                    <dl class="item-property">
                        <dt>Характеристики</dt>
                        <br>
                        <dd style="white-space: pre-wrap" v-html="product.desc"></dd>
                    </dl>
                    <div class="quantity" v-if="product.count > 0">
                        <div class="count">
                            <button v-if="quantity > 1" @click="minus" class="minus">
                                <i class="fa fa-minus-circle" aria-hidden="true"></i>
                            </button>
                            <input type="text" class="count_value" v-if="quantity"
                                v-model="quantity" name="count">
                            <input v-else class="count_value" value="1">
                            <button @click="plus" class="plus"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
                        </div>
                        <div class="remain"></div>
                        <div class="reserve d-flex mt-2">
                            <button class="reserve_btn btn btn-primary mr-4" @click="toReserve()">Зарезервировать</button>
                            <button @click="userCheck" :title="subscribe ? 'Отключить уведомление' : 'Уведомить о поступлении'" :class="subscribe ? 'active' : ''" class="alarm btn btn-default">
                                <i class="fa fa-bell" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="quantity" v-else>
                        <span>Весь товар был зарезервирован</span>
                    </div>
                </article>
            </aside>
        </div>
    </div>

</template>

<script>
    import {mapActions} from "vuex";

    import Swal from 'sweetalert2';
    import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'

    export default {
        name: "ProductWayPage",
        components: { VueSlickCarousel },

        data() {
            return {
                product: [],
                loading: false,
                quantity: 1,
                subscribe: false,
                way_issue: false,
            }
        },

        mounted() {
            this.getProduct()
        },

        methods: {

            ...mapActions({
                checkProductAction: 'checkProduct',
                getProductWithBasketAction: 'pushProductWithBasket',
            }),

            minus: function () {
                this.quantity--
            },

            plus: function () {
                if(this.quantity < this.product.count) {
                    this.quantity++;
                }
            },

            toReserve: function () {
                this.loading = true
                this.axios
                .post(this.axios.defaults.baseURL + 'to-reserve/' + this.$route.params.alias, {quantity: this.quantity})
                .then(response => {
                    console.log(response)
                    if(response.status === 200){
                        Swal.fire({
                            'icon': 'success',
                            'title': 'Товар успешно отправлен в резерв',
                            'showConfirmButton': false,
                            'timer': 2500
                        })

                        this.getProduct();
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false;
            });
            },

            getProduct: function() {
                this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'way-products/' + this.$route.params.alias)
                    .then(response => {
                        console.log(response)
                        this.getProductWithBasketAction({ product: response.data.item }).then(response => {
                            this.product = response
                            this.product.images = JSON.parse(response.images)
                        })

                        this.subscribe = response.data.subscribe
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false;
                });

                this.axios
                    .post(this.axios.defaults.baseURL + 'check-issue', {
                        'selected': 'Товары в пути'
                    })
                    .then(response => {
                        if(response.data.message == 'issued') {
                            this.way_issue = true
                        }
                    })
            },

            checkProduct: function() {
                this.checkProductAction({
                    'id': this.product.id,
                    'alias': this.product.alias,
                    'vendor_code': this.product.vendor_code,
                    'price': this.product.price,
                    'name': this.product.name,
                    'image': this.product.image,
                    'count': this.product.count
                })
            },

            userCheck: function() {
                this.subscribe = !this.subscribe
                this.loading = true
                this.axios
                .post(this.axios.defaults.baseURL + 'check-way/' + this.$route.params.alias, {subscribe: this.subscribe})
                .then(response => {
                    console.log(response)
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false;
                })
            },
        },

        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        }
    }
</script>

<style scoped lang="scss">
    
.slick-slide {
    display: flex;
    justify-content: center;
    position: relative;

    img {
        max-width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        margin: 0 auto;
    }
}

.slider-for {
    width: calc(100% - 74px);
    height: 500px;
    position: relative;
    overflow-y: visible;
}

    .alarm {
        &.active {
            color: red;
        }
    }

    .quantity {
        .count {
            position: relative;
            width: 125px;
            // margin: 0 auto;

            display: flex;
            justify-content: center;
            align-items: center;

            .count_value {
                width: 50px;
                padding: 5px;
                margin: 0 10px;
                text-align: center;
                border: 0;
                background-color: transparent;
            }

            button {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);

                background-color: transparent;
                border: 0;
                cursor: pointer;

                i {
                    font-size: 22px;
                }

                &.minus {
                    left: 0;
                }

                &.plus {
                    right: 0;

                    i {
                        &::before {
                            color: green;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/ProductWayPage.vue